<div #videoContainer>
  <div *rxLet="state$ as localState">
    @if (localState.video) {
      <div class="video-update-box flex flex-col gap-12">
        <h4 class="font-bold">{{ localState.video.title }}</h4>
        @if (localState.video.videoUrl) {
          <my7n-video-player
            [articleId]="localState.video.id"
            [config]="localState.videoPlayerConfig"
            [module]="LogVideoModules.VideoUpdateBox"
            [title]="localState.video.title"
            [videoUrl]="localState.video.videoUrl"
          ></my7n-video-player>
        }
      </div>
    }
  </div>
</div>
